module.exports = __webpack_public_path__ + "static/assets/ddcf42bdbf2cfc8e4db6d5a34fe5cfb1.png";